"use client"

import { useEffect } from "react";
import styles from "../css/components/SuccessNotification.module.css";
import { CheckCircle2 } from 'lucide-react';

const SuccessNotification = ({ message, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className={styles.successNotification}>
      <div className={styles.notificationContent}>
        <CheckCircle2 className={styles.successIcon} />
        <span>{message}</span>
      </div>
    </div>
  );
};

export default SuccessNotification;
